const WALLET_TRANSACTION = {
  FILTER_WALLET_TRANSACTION: "FILTER_WALLET_TRANSACTION",
  LOADING_WALLET_TRANSACTION: "LOADING_WALLET_TRANSACTION",
};

export default WALLET_TRANSACTION;
